// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ca2a9fde","455":"97b2d86f","977":"09884d83"}[chunkId] + ".chunk.js";
};